import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';

interface IRegUpdTextProps {
  updDt: number;
  userNm: string;
}

export const RegUpdText = observer(({ updDt, userNm }: IRegUpdTextProps) => {
  const viewUserNm = userNm === '(Unknown)' ? '알수없음' : userNm;
  return (
    <Typography
      variant={'body2'}
      color={'GrayText'}
      sx={{ ml: 1, display: 'flex', justifyContent: 'flex-end' }}
    >
      {'updated by ' + viewUserNm + ` (${dayjs(updDt).format('YYYY-MM-DD HH:mm:ss')})`}
    </Typography>
  );
});
